import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table'
import { BrandService } from '../../shared/services/brand.service';
import { Brand } from '../../shared/models/brand';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationModalService } from '../../shared/components/modals/confirmation-modal/confirmation-modal.service';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
declare var $: any;

@Component({
  selector: 'app-subbrands',
  templateUrl: './subbrands.component.html'
})

export class SubBrandsComponent implements OnInit {
  // MatPaginator Inputs
  length = 20;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 100];
  pageEvent: PageEvent;
  dataSource = new MatTableDataSource<Brand>();
  displayedColumns: string[] = ['name', 'phone', 'email', 'url', 'isActive','actions'];
  brandForm: FormGroup;
  submitted = false;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private brandService: BrandService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private notification: MatSnackBar,
    private confirmationModalService: ConfirmationModalService,
    private formBuilder: FormBuilder
  ) { }

  private _id; // private property _item

  // use getter setter to define the property
  get id(): any {
    return this._id;
  }

  @Input()
  set id(val: any) {
    this._id = val;
  }

  // call get locations on load 
  ngOnInit() {
    this.getRecords(this.id);

    // initialize brand form
    this.brandForm = this.formBuilder.group({
      name: ['', Validators.required],
      brandId: [this.id, Validators.required]
    });
  }

  // get locations
  getRecords(id: number): void {
    if (id > 0) {
      this.brandService.getChildren(id).subscribe(result => {
        if (result.length) {
          this.dataSource.data = result;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }

      }, error => console.error(error));
    }
  }

  // add new brand form submission
  addBrand() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.brandForm.invalid) {
      return;
    }
      
    this.brandService.add({ name: this.brandForm.value["name"], brandId: +this.brandForm.value["brandId"] } as Brand)
      .subscribe(item => {
        this.getRecords(this.id);
        this.showNotification('Your brand was successuly added!', 'Okay!');
        this.resetAddBrandForm();
        this.hideAddBrandModal();
      }); 
  }

  hideAddBrandModal() {
    $('#addBrandModal').modal('hide');
  }
  
  // reset addBrandForm
  resetAddBrandForm() {
    this.submitted = false;
    this.brandForm.controls['name'].setValue('');
  } 

  //// open add form for location
  //openAddModal() {
  //  const modalRef = this.modalService.open(LocationAddFormComponent);
  //  modalRef.componentInstance.title = 'Add a brand Location';
  //  modalRef.componentInstance.brandId = this.id;

  //  // modal result
  //  modalRef.result.then((result) => {
  //    if (result) {
  //      this.getRecords(this.id);
  //    }
  //  }).catch(() =>
  //    console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
  //  );
  //}

  //// delete location
  //deleteLocation(id: number) {

  //  this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete this item?')
  //    .then((confirmed) => {
  //      if (confirmed) {
  //        this.storeLocationService.delete(id).subscribe(() => {
  //          this.showNotification('The store location has been deleted successfully!', 'Okay!');
  //          this.getRecords(this.id);
  //        });
  //      }
  //    }
  //    )
  //    .catch(() =>
  //      console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
  //    );
  //}

  //// edit location
  //editLocation(location: StoreLocation) {

  //  const modalRef = this.modalService.open(LocationEditFormComponent);
  //  modalRef.componentInstance.title = 'Edit Store Location';
  //  modalRef.componentInstance.location = location;

  //  // modal result
  //  modalRef.result.then((result) => {
  //    if (result) {
  //      this.getRecords(this.id);
  //    }
  //  }).catch(() =>
  //    console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
  //  );
  //}

  // filter locations
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  // show notification popup
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
  }

}

